import React from 'react';
import ReactDOM from 'react-dom/client';
import PensionCalculator from './components/PensionCalculator';
import './index.css';

class WebComponent extends HTMLElement {
  connectedCallback() {
    const root = ReactDOM.createRoot(this);
    root.render(
      <React.StrictMode>
        <PensionCalculator
          backURL={this.getAttribute('backURL')}
          startURL={this.getAttribute('startURL')}
          targetAmount={this.getAttribute('targetAmount')}
          initialAmount={this.getAttribute('initialAmount')}
          annualIncreaseRate={this.getAttribute('annualIncreaseRate')}
          retirementAge={this.getAttribute('retirementAge')}
          monthlySavings={this.getAttribute('monthlySavings')}
        />
      </React.StrictMode>
    );
  }
}

const ELEMENT_NAME = 'icea-lion-pension-calculator';

if (!customElements.get(ELEMENT_NAME)) {
  customElements.define(ELEMENT_NAME, WebComponent);
}

// For development mode, render to root div
if (import.meta.env.DEV) {
  const rootElement = document.getElementById('root');
  if (rootElement) {
    const root = ReactDOM.createRoot(rootElement);
    root.render(
      <React.StrictMode>
        <PensionCalculator />
      </React.StrictMode>
    );
  }
}

